import { io, type Socket } from 'socket.io-client';

import { getAccessToken } from '@lib/axios';
import env from '@config/env';

const SOCKET_ORIGIN = env.socketOrigin;

let _socket: Socket | null = null;

export const getSocket = (): Socket | null => _socket;

export const connectSocket = (centreId: string, sessionId: string): Socket => {
  if (_socket) {
    _socket.disconnect();
  }

  _socket = io(SOCKET_ORIGIN, {
    path: '/socket.io',
    // Prefer a raw WebSocket; only fall back to HTTP long-polling if the
    // WebSocket handshake fails (e.g. a proxy that won't upgrade the connection).
    // Without tryAllTransports, socket.io only attempts the first transport and
    // the connection dies instead of falling back.
    transports: ['websocket', 'polling'],
    tryAllTransports: true,
    auth: { token: getAccessToken(), centreId, sessionId },
    reconnection: true,
  });

  return _socket;
};

export const disconnectSocket = (): void => {
  _socket?.disconnect();
  _socket = null;
};

// Call this after every access-token refresh so the socket stays on the current identity.
export const refreshSocketAuth = (): void => {
  if (!_socket) return;
  _socket.auth = { ...(_socket.auth as Record<string, unknown>), token: getAccessToken() };
  _socket.disconnect().connect();
};

// NOTE: there is no in-place scope switcher here on purpose. Every centre /
// main-centre / session change hard-reloads (see useScopeSwitcher), so the
// socket is rebuilt by connectSocket with the new scope in its handshake. The
// server still accepts a `scope:set` event if an in-place switch is ever needed
// again.
